export const anchorOriginDefault = {
  vertical: 'top',
  horizontal: 'right',
};
